'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import refType from '@mui/utils/refType';
import composeClasses from '@mui/utils/composeClasses';
import capitalize from "../utils/capitalize.js";
import nativeSelectClasses, { getNativeSelectUtilityClasses } from "./nativeSelectClasses.js";
import { styled } from "../zero-styled/index.js";
import rootShouldForwardProp from "../styles/rootShouldForwardProp.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, variant = ownerState.variant, disabled = ownerState.disabled, multiple = ownerState.multiple, open = ownerState.open, error = ownerState.error;
    var slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            "icon".concat(capitalize(variant)),
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return composeClasses(slots, getNativeSelectUtilityClasses, classes);
};
export var StyledSelectSelect = styled('select', {
    name: 'MuiNativeSelect'
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        }
    }, _define_property(_obj, "&.".concat(nativeSelectClasses.disabled), {
        cursor: 'default'
    }), _define_property(_obj, '&[multiple]', {
        height: 'auto'
    }), _define_property(_obj, '&:not([multiple]) option, &:not([multiple]) optgroup', {
        backgroundColor: (theme.vars || theme).palette.background.paper
    }), _define_property(_obj, "variants", [
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.variant !== 'filled' && ownerState.variant !== 'outlined';
            },
            style: {
                // Bump specificity to allow extending custom inputs
                '&&&': {
                    paddingRight: 24,
                    minWidth: 16 // So it doesn't collapse.
                }
            }
        },
        {
            props: {
                variant: 'filled'
            },
            style: {
                '&&&': {
                    paddingRight: 32
                }
            }
        },
        {
            props: {
                variant: 'outlined'
            },
            style: {
                borderRadius: (theme.vars || theme).shape.borderRadius,
                '&:focus': {
                    borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                },
                '&&&': {
                    paddingRight: 32
                }
            }
        }
    ]), _obj;
});
var NativeSelectSelect = styled(StyledSelectSelect, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: rootShouldForwardProp,
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            _define_property({}, "&.".concat(nativeSelectClasses.multiple), styles.multiple)
        ];
    }
})({});
export var StyledSelectIcon = styled('svg', {
    name: 'MuiNativeSelect'
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active
    }, _define_property(_obj, "&.".concat(nativeSelectClasses.disabled), {
        color: (theme.vars || theme).palette.action.disabled
    }), _define_property(_obj, "variants", [
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.open;
            },
            style: {
                transform: 'rotate(180deg)'
            }
        },
        {
            props: {
                variant: 'filled'
            },
            style: {
                right: 7
            }
        },
        {
            props: {
                variant: 'outlined'
            },
            style: {
                right: 7
            }
        }
    ]), _obj;
});
var NativeSelectIcon = styled(StyledSelectIcon, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.icon,
            ownerState.variant && styles["icon".concat(capitalize(ownerState.variant))],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ var NativeSelectInput = /*#__PURE__*/ React.forwardRef(function NativeSelectInput(props, ref) {
    var className = props.className, disabled = props.disabled, error = props.error, IconComponent = props.IconComponent, inputRef = props.inputRef, _props_variant = props.variant, variant = _props_variant === void 0 ? 'standard' : _props_variant, other = _object_without_properties(props, [
        "className",
        "disabled",
        "error",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        disabled: disabled,
        variant: variant,
        error: error
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NativeSelectSelect, _object_spread({
                ownerState: ownerState,
                className: clsx(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ _jsx(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * The CSS class name of the select element.
   */ className: PropTypes.string,
    /**
   * If `true`, the select is disabled.
   */ disabled: PropTypes.bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: PropTypes.bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: PropTypes.elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: refType,
    /**
   * @ignore
   */ multiple: PropTypes.bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: PropTypes.string,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: PropTypes.func,
    /**
   * The input value.
   */ value: PropTypes.any,
    /**
   * The variant to use.
   */ variant: PropTypes.oneOf([
        'standard',
        'outlined',
        'filled'
    ])
} : void 0;
export default NativeSelectInput;
